import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import React from "react";
import FuelCardsReports from "./cardfuel/sections/FuelCardsReports";
import FuelCard from "./cardfuel/sections/FuelCard";
import { useHasScope } from "../../../config/globalConfig";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import { SCOPE_FINANCE_FUEL_CARD } from "./cardfuel/constants/FuelCardAuth";

const PageFuelCards = () => {
    const {t} = useTranslation('finance', {keyPrefix: 'fuel'});
    const hasScope = useHasScope;

    return (
        hasScope(SCOPE_FINANCE_FUEL_CARD) ?
            <Routes>
                <Route path="/" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <FuelCardsReports/>
                    </>
                }/>
                <Route path="/details/:id" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <FuelCard/>
                    </>
                }/>
            </Routes>
        : <NotAuthorizedDialog/>
    );
}

export default PageFuelCards;